export default function($) {

    "use strict";

    //Checks if li has sub (ul) and adds class for toggle icon - just an UI
    $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
    $("#menu-icon-close").hide();

    if ($(window).width() <= 960) {
      $("#main-nav").append($("#quick-links"));
    }

    //Adds menu-mobile class (for mobile toggle menu) before the normal menu
    //Mobile menu is hidden if width is more then 959px, but normal menu is displayed
    //Normal menu is hidden if width is below 959px, and jquery adds mobile menu
    //Done this way so it can be used with wordpress without any trouble
    $(".menu > ul > li").hover(function (e) {
        if ($(window).width() > 960) {
            $(this).children("ul").stop(true, false).toggle();
            e.preventDefault();
        }
    });
    //If width is more than 960px dropdowns are displayed on hover

    $(".menu > ul > li").click(function () {
        if ($(window).width() <= 960) {
          var $mobile_submenu_title = $("<h2>").text($(this).children("a").text());
          if ($(this).hasClass("menu-item--gammes")) {
            $mobile_submenu_title.addClass("mobile-sub-menu-title--gammes");
          }
          $("#mobile-sub-menu-wrapper").append($mobile_submenu_title);
          $(this).children("ul").clone().show().appendTo("#mobile-sub-menu-wrapper");
          $("#mobile-sub-menu-wrapper").show().animate({ left: "0px" }, 125);
          $("#mobile-sub-menu-close").show();
        }
    });

  $("#mobile-sub-menu-close").click(function() {
    $("#mobile-sub-menu-wrapper").hide().html("").animate({ left: "100%" }, 125);
    $("#mobile-sub-menu-close").hide();
  });
    //If width is less or equal to 960px dropdowns are displayed on click (thanks Aman Jain from stackoverflow)

    // Prevent click on first level links with children
    $(".menu > ul > li:has( > ul) > a").click(function (e) {
        e.preventDefault();
    })

    $(".menu-mobile").click(function (e) {
      e.preventDefault();
      $(".menu > ul").toggleClass('show-on-mobile').animate({ left: "0px" }, 125);
      $("#quick-links").toggleClass('show-on-mobile').animate({ left: "0px" }, 125);
      $("#menu-icon-close").toggle();
      $("#menu-icon-open").toggle();
      $("#mobile-sub-menu-wrapper").hide().html("").attr("left", "100%");
      $("#mobile-sub-menu-close").hide();
    });
    //when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story (thanks mwl from stackoverflow)

}
